module.exports = __webpack_public_path__ + "static/media/plan_lekcji_1.54cda154.png";